export const Footer = () => {
  return (
    <footer>
      <span>&#169; {new Date().getFullYear()} Andrew Kagotho</span>
    </footer>
  )
}
